module.exports = __webpack_public_path__ + "img/tipoboton01.270cb51.svg";